import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=54918d80"
import script from "./setting?vue&type=script&lang=js&external"
export * from "./setting?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports